import { Box, Paper, Typography, useTheme } from "@mui/material";

import { TYPES } from "pages/Deposit/constants";

const digital = 4;

export function AcceptWithdrawTextAll({ coinDigital, typeId }) {
  const theme = useTheme();

  if (coinDigital === digital && typeId === TYPES?.sanaCash) {
    return (
      <Box component={Paper} p={1} textAlign="right">
        <Typography variant="subtitle1" textAlign="center" dir="rtl">
          به محض دریافت درخواست شما SanaCash درخواست شما را بررسی کرده و در سریع
          ترین زمان مبلغ درخواستی را به حساب اعلامی واریز خواهد کرد و شماره سند
          واریزی برای شما ارسال خواهد شد. مبالغ درخواستی TOMAN با توجه به
          محدودیت های بانکی و ساعات کاری بانکها 24 تا 48 ساعت بعد از درخواست به
          حساب بانکی شما واریز خواهد شد.
        </Typography>
      </Box>
    );
  } else if (coinDigital === digital && typeId === TYPES?.internal) {
    return (
      <Box component={Paper} p={1} textAlign="right">
        <Typography variant="subtitle1" textAlign="center" dir="rtl">
          مبلغ درخواستی TOMANبصورت آنی به حساب گیرنده واریز خواهد شد، لطفا در
          مراحل بعد از نام کاربری دریافت کننده مبلغ، مطمئن شوید.
        </Typography>
      </Box>
    );
  } else if (coinDigital !== digital && typeId === TYPES?.internal) {
    return (
      <>
        <Box
          component={Paper}
          p={1}
          mb={2}
          bgcolor={theme.palette.background.default}
        >
          <Typography variant="subtitle1">
            Ensure that the address is correct and on the same network
          </Typography>

          <Typography variant="subtitle1">
            <Typography variant="subtitle1" color="error" component="span">
              Important:
            </Typography>{" "}
            Transaction cannot be cancelled
          </Typography>
        </Box>

        <Box
          component={Paper}
          p={1}
          textAlign="right"
          bgcolor={theme.palette.background.default}
        >
          <Typography variant="subtitle1" dir="rtl">
            از آدرس ولت مقصد و شبکه ای که انتخاب کرده اید اطمینان حاصل کنید.
          </Typography>

          <Typography variant="subtitle1" dir="rtl">
            <Typography variant="subtitle1" color="error" component="span">
              مهم:{" "}
            </Typography>{" "}
            توجه داشته باشید که تراکنش ها غیر قابل کنسل و برگشت می‌باشند.
          </Typography>

          <Typography variant="subtitle1" dir="rtl" pt={1}>
            <Typography variant="subtitle1" color="error" component="span">
              توجه:{" "}
            </Typography>{" "}
            در تایپ internal شما می توانید ارز موردنظر خود را بدون کارمزد به
            دیگر کاربران ساناکش انتقال دهید، برای انجام اینکار شما باید کد کاربر
            دریافت کننده را داشته باشید.
          </Typography>
        </Box>
      </>
    );
  } else {
    return (
      <>
        <Box
          component={Paper}
          p={1}
          mb={2}
          bgcolor={theme.palette.background.default}
        >
          <Typography variant="subtitle1">
            Ensure that the address is correct and on the same network
          </Typography>

          <Typography variant="subtitle1">
            <Typography variant="subtitle1" color="error" component="span">
              Important:
            </Typography>{" "}
            Transaction cannot be cancelled
          </Typography>
        </Box>

        <Box
          component={Paper}
          p={1}
          textAlign="right"
          bgcolor={theme.palette.background.default}
        >
          <Typography variant="subtitle1" dir="rtl">
            از آدرس ولت مقصد و شبکه ای که انتخاب کرده اید اطمینان حاصل کنید.
          </Typography>

          <Typography variant="subtitle1" dir="rtl">
            <Typography variant="subtitle1" color="error" component="span">
              مهم:{" "}
            </Typography>{" "}
            توجه داشته باشید که تراکنش ها غیر قابل کنسل و برگشت می‌باشند.
          </Typography>
        </Box>
      </>
    );
  }
}
